import { LuMonitor, LuMoon, LuSun } from "react-icons/lu";
import { useIsCompactView } from "../../../core_stores/useIsCompactViewStore";
import { Theme, useTheme } from "../../../providers/ThemeProvider";

const themeOptions = [
  {
    key: "light",
    label: "Light",
    icon: <LuSun size={24} />,
  },
  {
    key: "dark",
    label: "Dark",
    icon: <LuMoon size={24} />,
  },
  {
    key: "system",
    label: "System",
    icon: <LuMonitor size={24} />,
  },
];

export default function PersonalSettingsAppearance() {
  const { theme, setTheme } = useTheme();
  const isCompactView = useIsCompactView();

  return (
    <div
      className="text-dark-text
    flex flex-col gap-4"
    >
      <div className="flex flex-col gap-1">
        <span className="font-semibold">Theme</span>
        <span className="font-[300]">Choose your preferred color scheme</span>
      </div>
      <div className={`${isCompactView && "flex-col"} flex gap-4`}>
        {themeOptions.map((option) => (
          <button
            key={option.key}
            className={`flex flex-col items-center justify-center 
                flex-1 rounded-[6px] border transition-all duration-300 
                text-sm font-medium py-4 gap-1
                ${
                  theme === option.key
                    ? "border-primary-blue"
                    : "border-light-text dark:border-dark-text hover:border-primary-blue dark:hover:border-primary-blue"
                }
              `}
            onClick={() => setTheme(option.key as Theme)}
          >
            {option.icon}
            {option.label}
          </button>
        ))}
      </div>
      <div
        className="rounded-[6px] 
      border border-primary-blue px-4 py-3
      text-primary-blue text-sm"
      >
        {theme.charAt(0).toUpperCase() + theme.slice(1)} Mode is currently
        active
      </div>
    </div>
  );
}
